import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import { type CustomerEntity } from '@/libs/api'
import { type CustomersOrder } from '@/libs/api/types'

import { getCustomersSelectQueryOptions } from '../query-options'

/**
 * Select用の荷主一覧のUseQuery
 */
export const useCustomersSelectQuery = (
  tenantKey: string,
  options?: {
    disabled?: boolean
    dcIds?: number[]
    orders?: CustomersOrder[]
    shippingDate?: string
  }
): UseQueryResult<CustomerEntity[]> => {
  const disabled = options?.disabled ?? false
  const dcIds = options?.dcIds
  const orders = options?.orders
  const shippingDate = options?.shippingDate
  return useQuery<CustomerEntity[]>({
    ...getCustomersSelectQueryOptions(tenantKey, dcIds, orders, shippingDate),
    enabled: !disabled,
    retry: false
  })
}
